import { AIRecommendation } from '@/apps/AIAssistant/types';
import handleException from '@/common/utils/errors';

// Local storage keys
export const STORAGE_KEY = 'ai_assistant_recommendations';
export const LAST_UPDATED_KEY = 'ai_assistant_last_updated';

/**
 * Loads recommendations from local storage
 */
export const loadRecommendationsFromStorage = (): {
  recommendations: AIRecommendation[],
  lastUpdated: string | null
} => {
  try {
    const storedRecommendations = localStorage.getItem(STORAGE_KEY);
    const lastUpdated = localStorage.getItem(LAST_UPDATED_KEY);

    return {
      recommendations: storedRecommendations ? JSON.parse(storedRecommendations) : [],
      lastUpdated: lastUpdated || null
    };
  } catch {
    // Silent error handling
    return { recommendations: [], lastUpdated: null };
  }
};

/**
 * Saves recommendations to local storage
 */
export const saveRecommendationsToStorage = (
  recommendations: AIRecommendation[],
  lastUpdated: string | null
): void => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(recommendations));
    if (lastUpdated) {
      localStorage.setItem(LAST_UPDATED_KEY, lastUpdated);
    } else {
      localStorage.removeItem(LAST_UPDATED_KEY);
    }
  } catch (error) {
    handleException(error);
  }
};
